module.exports = __webpack_public_path__ + "img/door-closed.aa4cc652.svg";